module.exports = __webpack_public_path__ + "files/cdbfa4220a6ed7ff4936f28ffd74a826.svg";